import filter from 'lodash/filter';
import head from 'lodash/head';

export class MilepostArchiveService {
	constructor($resource, ApiService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;
	}

	/* #################################### PUBLIC METHODS ######################################### */

	/**
	 * function to get milepost content
	 * @return {object} [information related to milepost]
	 */
	getMilepostArchiveReportFilterDetails({ limit = 10, pageId = 1 }, endPoint) {
		this.milepostFilterResourceUrl = this.apiService.getResourceUrl(`menus/${endPoint}`);
		this.milepostFilterResource = this.$resource(this.milepostFilterResourceUrl);

		const promise = this.milepostFilterResource.get({
			limit,
			page_id: pageId
		}).$promise;

		return promise.then(details => this._getMilepostFilterDetailsObject(details))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	/* #################################### PRIVATE METHODS ######################################### */
	
	getMilepostDetailsObject(values) {
		let details = filter(values, ['name', 'Milepost']);
		return _getContentData(head(details).values);

		function _getContentData(data) {
			return data.map(value => ({
				pdf: value.pdf,
				title: value.title,
				image: value.image,
				description: value.description,
				createdAt: value.created_at
			}));
		}
	}

	_getMilepostFilterDetailsObject(details) {
		let detailsObject = {};
		detailsObject.details = this.getMilepostDetailsObject([details.data]);
		if (details.data.hasOwnProperty('count')) {
			detailsObject.count = details.data.count;
		}
		return detailsObject;
	}

	
}


// WEBPACK FOOTER //
// ./src/app/components/publications-documents-milepost-archive/publications-documents-milepost-archive.service.js